import React, { useEffect, useRef, useState } from 'react'
import { Box, Typography, Divider, Button, Dialog, DialogContent } from '@mui/material'
import { AltRoute, CancelOutlined } from '@mui/icons-material'
import { ApiGetAgreement } from '../../apiService/Core/Apicall.tsx'
import Loading from '../Loader/Loading.tsx'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'



function Terms() {
    const [condition, setcondition] = useState<any>()
    const loading = useSelector((state: any) => state.loader.isLoading);
    const navigate = useNavigate()



    useEffect(() => {
        const getagreement = async () => {

            try {
                const res = await ApiGetAgreement()
                setcondition(res)
            } catch (error) {
                const message =
                    error?.response?.data?.message || // API error message
                    error?.message ||                 // JS error message
                    String(error);
                toast.error(message)
            }
        }
        getagreement()
    }, [])
    return (
        <Box>
            <Box padding='20px' className='w-100 custom-bg d-flex align-items-center justify-content-between' height='72px'>
                <Typography className='text-white fs-4 p-0 m-0'>Terms & Conditions</Typography>
                <CancelOutlined className='fs-4 text-white' />
            </Box>
            <Box padding='20px'>
                <Box className='terms'>
                    <div dangerouslySetInnerHTML={{ __html: condition }} />
                </Box>

            </Box>
            <Box className='d-flex justify-content-between'>
                <Button className='button-primary px-4 mx-auto py-2 mb-2' onClick={() => { navigate(-1) }}>Back</Button>
            </Box>
            {loading && <Loading />}
        </Box>
        // <Box
        //     className="terms"
        //     border="1px solid green"
        //     sx={{
        //         minHeight: '500px',
        //         height: 'fit-content',
        //         width: '100%',
        //         display: 'block',
        //         padding: 2, // optional padding
        //     }}
        // >
        //     <Typography fontSize="14px" className="mb-1">
        //         Hi <strong>{userData.firstName}</strong>, please read and accept terms of shopper agreement below.
        //     </Typography>

        //     <div
        //         dangerouslySetInnerHTML={{ __html: condition }}
        //         style={{
        //             minHeight: '100%',
        //             border: '2px solid red',
        //             width: '100%',
        //             display: 'block',
        //         }}
        //     />
        //     <Box padding='20px'>
        //         <Divider orientation='horizontal' sx={{ borderColor: '#00000033', border: '1px solid #00000033' }} />
        //         <Box className='d-flex flex-column flex-md-row justify-content-between'>
        //             <Button variant='outlined' className='button-primary-outlined my-3 py-2 px-70'>Disagree</Button>
        //             <Button className='button-primary my-3 py-2 px-70' onClick={() => { setopenSignature(true) }}>Agree</Button>
        //         </Box>

        //     </Box>
        //     <Dialog open={openSignature} onClose={() => setopenSignature(false)}>
        //         <DialogContent>
        //             <div>
        //                 <ReactSketchCanvas
        //                     ref={canvasRef}
        //                     strokeColor="black"
        //                     strokeWidth={3}
        //                     canvasColor="none"
        //                     style={{
        //                         backgroundColor: 'transparent',
        //                         border: '2px solid #000',
        //                         borderRadius: '8px',
        //                         width: '500px',
        //                         height: '200px',
        //                     }}
        //                 />
        //                 <div style={{ marginTop: '10px' }}>
        //                     <Box className='d-flex flex-column flex-md-row justify-content-between'>
        //                         <Button variant='outlined' className='button-primary-outlined my-3 py-2 px-3' onClick={handleClear}>Clear</Button>
        //                         <Button className='button-primary my-3 py-2 px-3' onClick={handleSave}>Upload Signature</Button>
        //                     </Box>
        //                 </div>
        //             </div>
        //         </DialogContent>
        //     </Dialog>
        // </Box>
    )
}

export default Terms
